import * as React from "react";
import { connect } from "react-redux";
import { Modal, ModalBody } from 'reactstrap';
import GoogleMapMain from "../../common/googleMapMain";
import PharmacyHeader from "../PharmacyHeader";
import { formatPhoneNumber } from "../../../helpers/formatting";
import { getDirectionsUrl, findDistance, formatMiles } from "../../../helpers/location";
import * as types from "../../../constants/actionTypes";
import SectionLoading from '../../common/SectionLoading';
import SectionLoadingError from '../../common/SectionLoadingError';
import OperationHours from '../OperationHours';
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import * as d from "../../../reducers/domainReducer";
import { getCityOrZip } from "../../../api/typeaheadApi";
import AutocompleteInput from "../../common/input/AutocompleteInput";
import Cookies from "cookies-js";
import FeatureDisabled from "../../common/FeatureDisabled";
const USE_CURRENT_LOCATION = 'Current Location';

class FindPharmacy extends React.Component {
    constructor(props, params) {
        super(props, params);
        this.onClickPreOpen = this.onClickPreOpen.bind(this);
        this.onSearch = this.onSearch.bind(this);
        const locationFromStorage = Cookies.get('location_' + this.props.userDetails.userName);
        this.state = {
            cItems: [],
            value: locationFromStorage !== null && locationFromStorage !== undefined ? locationFromStorage : !props.waitingOnGeoAddress ? props.cityAddress && props.stateAddress ? `${props.cityAddress},${props.stateAddress}` : '' : '',
            showModal: false,
            selectedPharmacy: null,
            listView: true,
            latitude: '',
            longitude: '',
            isGeoLocation: true,
            currentLocationSelected: false,
            cityZipLoading: false,
            cityZipNoResults: false,
            showSelectedPharmacy: false
        };
        this.cTime = 0;
    }

    componentDidMount() {
        this._isMounted = true;
        const { cityAddress, stateAddress, latitude, longitude } = this.props;
        let isGeoAddress = '';
        if (this.state.value) {
            isGeoAddress = this.state.value;
        } else if (cityAddress && stateAddress) {
            isGeoAddress = `${cityAddress},${stateAddress}`
        }
        if (isGeoAddress === USE_CURRENT_LOCATION) {
            if (latitude && longitude) {
                this.props.getPharmacyList(isGeoAddress, latitude, longitude);
            } else {
                if (cityAddress && stateAddress) {
                    isGeoAddress = `${cityAddress},${stateAddress}`
                }
                this.props.getPharmacyList(isGeoAddress); //initial load of default all pharmacylist
            }
        } else {
            this.props.getPharmacyList(isGeoAddress); //initial load of default all pharmacylist
        }
        logUI("MBHWeb.UI.Rx.FindPharmacy.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState) {
        const { getPharmacyList, pharmacyListWaiting, isLoggedIn, latitude, longitude, geoLocationError, cityAddress, stateAddress, waitingOnGeolocation } = this.props;
        const { value, currentLocationSelected } = this.state;
        const locationFromStorage = Cookies.get('location_' + this.props.userDetails.userName);
        if (!waitingOnGeolocation && prevProps.latitude === null && this.props.latitude) {
            this.onCompleteSelect(USE_CURRENT_LOCATION);
        }
        if (locationFromStorage !== null && locationFromStorage !== undefined) {
            if (locationFromStorage === USE_CURRENT_LOCATION) {
                /* if (value === "" && isLoggedIn && !this.domainChanged && latitude && !pharmacyListWaiting) { // if the data in storage is Current Location and latitude prop is there
                     this.setState({ value: USE_CURRENT_LOCATION }, () => {
                         getPharmacyList(USE_CURRENT_LOCATION, latitude, longitude);
                         this.domainChanged = true;
                     });
                 }
                 else if (value === "" && !latitude && !this.domainChanged) {  // if the data in storage is Current Location and latitude prop becomes undefined in case of reload
                     this.props.getGeoLocation(true);
                     this.onCompleteSelect(USE_CURRENT_LOCATION);
                     this.domainChanged = true;
                 }*/
                if (value === "" && !this.domainChanged && !this.props.latitude) {
                    this.props.getGeoLocation(true);
                    this.domainChanged = true;
                }


            }
            else if (value === "" && isLoggedIn && !this.domainChanged && !pharmacyListWaiting) { // if the data in storage is city/zip
                this.setState({ value: locationFromStorage }, () => {
                    getPharmacyList(this.state.value);
                    this.domainChanged = true;
                });
            }
        }
        else {
            if (value === "" && isLoggedIn && !this.domainChanged && !pharmacyListWaiting && cityAddress && stateAddress) { // no data in storage
                this.setState({ value: `${cityAddress},${stateAddress}` }, () => {
                    getPharmacyList(this.state.value);
                    this.domainChanged = true;
                });
            }
        }

        if (geoLocationError !== undefined && geoLocationError !== "" && geoLocationError !== prevProps.geoLocationError) {
            this.setState({ isGeoLocation: geoLocationError && currentLocationSelected ? false : true, value: ((value === USE_CURRENT_LOCATION) ? '' : value) });
        }
        else if (geoLocationError === "" && geoLocationError !== prevProps.geoLocationError) {
            this.setState({ isGeoLocation: true });
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    togglePharmacySelection(pharmacy) {
        const list = this.props.matchingPharmacyList;
        if (pharmacy) {
            const storeNumber = pharmacy.StoreNumber;
            for (let i = 0; i < list.length; i++) {
                if (list[i].StoreNumber === storeNumber) {
                    pharmacy.Address.Distance = list[i].Address.Distance;
                    break;
                }
            }
        }
        this.setState({ selectedPharmacy: pharmacy, showSelectedPharmacy: true });
    }

    setListView(isListView) {
        this.setState({ listView: isListView });
    }

    showConfirmModal(pharmacy) {
        this.setState({ showModal: true, selectedPharmacy: pharmacy });
    }

    close(pharmacy) {
        const { action, onAction } = this.props;
        if (action) {
            onAction(pharmacy ? this.state.selectedPharmacy : null);
        }
        this.setState({ showModal: !this.state.showModal, selectedPharmacy: null });
    }

    setDefaultPharmacy() {
        const { setFavouritePharmacy, showAsModal, userDetails, onClose } = this.props;
        const selectedPharmacy = this.state.selectedPharmacy;
        this.togglePharmacySelection(null);
        setFavouritePharmacy(selectedPharmacy.StoreNumber, userDetails);
        if (showAsModal) {
            onClose(selectedPharmacy);
        }
        else {
            this.close(selectedPharmacy);
        }
        logUI("MBHWeb.Rx.SetDefaultPharmacy.Post", new Date(), Tools.getURLPath(), JSON.stringify({ storeNumber: selectedPharmacy.StoreNumber }));
    }

    transfer(pharmacy) {
        if (this.props.rxDown || pharmacy.IsDefault || !this.props.hasPharmacyLogin) {
            this.props.onAction(pharmacy);
        }
        else {
            this.setState({ actedOnPharmacy: true, showSelectedPharmacy: false });
            this.showConfirmModal(pharmacy);
        }
    }

    onCompleteChange(value) {
        if (this._isMounted) {
            if (value !== "") {
                this.setState({ cityZipLoading: true }, () => {
                    let dt = new Date();
                    getCityOrZip({ filter: value }, dt.valueOf())
                        .then(json => {
                            if (this.cTime < json.timestamp) {
                                this.cTime = json.timestamp;
                                let items = [];
                                json = json.results;
                                if (json) {
                                    for (var term in json) {
                                        items.push({ id: json[term].zip_city, label: json[term].zip_city });
                                    }
                                }
                                this.setState({ cItems: items, cityZipLoading: false, cityZipNoResults: !(items.length > 0) });
                            }
                        });
                });
            }

            this.setState({ value: value, currentLocationSelected: false });
        }
    }

    onCompleteSelect(value) {
        if (value === USE_CURRENT_LOCATION) {
            this.setState({ currentLocationSelected: true, value: value });
            if (this.props.latitude && this.props.longitude) {
                Cookies.set('location_' + this.props.userName, value, { domain: Tools.getDomain(location.href) });
            } else {
                //Cookies.expire('location_' + this.props.userName, { domain: Tools.getDomain(location.href) });
            }
        }
        else {
            Cookies.set('location_' + this.props.userName, value, { domain: Tools.getDomain(location.href) });
            this.setState({ currentLocationSelected: false, value: value });
        }
        const { getPharmacyList, latitude, longitude } = this.props;
        getPharmacyList(value, latitude, longitude);
        logUI("MBHWeb.Rx.FindPharmacy.SelectCity", new Date(), Tools.getURLPath(), JSON.stringify({ cityOrZip: value, latitude: latitude, longitude: longitude }));
    }

    sortBasedOnDistance = (PharmacyListDefault) => {
        var tempPharmacyListDefault = [];
        PharmacyListDefault.map(item => {
            item.Address.Distance = findDistance(this.state.latitude, this.state.longitude, item.Address.Latitude, item.Address.Longitude, "M"); //just used the existing unused property from api to sort it by miles.
            tempPharmacyListDefault.push(item);
        });
        return tempPharmacyListDefault.sort(function (a, b) {
            return a.Address.Distance < b.Address.Distance ? -1 : 1;
        });
    }

    onSearch(value) {
        this.setState({ value: value });
        const { getPharmacyList, latitude, longitude } = this.props;
        getPharmacyList(value, latitude, longitude);
        logUI("MBHWeb.Rx.FindPharmacy", new Date(), Tools.getURLPath(), JSON.stringify({ cityOrZip: value, latitude: latitude, longitude: longitude }));
    }

    redirectToMap(item) {
        if (item && item.Address) {
            const toAddress = item.Address.StreetAddress + ', ' + item.Address.City + ', ' + item.Address.State + ' ' + item.Address.Zip;
            var addressUrl = getDirectionsUrl(null, toAddress);
            if (addressUrl) {
                window.open(addressUrl, "_blank");
                logUI("MBHWeb.Rx.FindPharmacy.RedirectMap", new Date(), Tools.getURLPath(), JSON.stringify({ addressUrl: addressUrl }));
            }
        }
    }

    onClickPreOpen() {
        if (this._isMounted) {
            this.props.getGeoLocation(true);
            this.onCompleteSelect(USE_CURRENT_LOCATION);

        }
    }

    submitForm(value) {
        if (value) {
            this.onSearch(value);
        }
    }

    render() {
        const {
            rxDown, hasPharmacyLogin, showAsModal, action, matchingPharmacyList, pharmacyListWaiting, pharmacyServiceError,
            latitude, longitude, currentPharmacyUser, geoLocationError, selectedStoreNumber
        } = this.props;
        const { cItems, value, showModal, listView, selectedPharmacy, isGeoLocation, currentLocationSelected, cityZipLoading, cityZipNoResults, showSelectedPharmacy } = this.state;
        const isCurrentLocation = (!latitude || !longitude || longitude === null || longitude === null) ? false : true;
        let cityZip = currentLocationSelected && isCurrentLocation ? USE_CURRENT_LOCATION : (currentLocationSelected && !isCurrentLocation) ? '' : value;
        const isGeoCurrentLocationDisabled = currentLocationSelected && (cityZip === '');

        let pharmacyList = matchingPharmacyList, isSortedByDistance = false;
        if (pharmacyList && pharmacyList.length > 0)
            isSortedByDistance = !value ? false : (pharmacyList[0].Address.Distance ? true : false); //check value is not empty and there is a distance

        if (typeof pharmacyList !== 'undefined' && selectedStoreNumber && selectedStoreNumber !== "") {  //removing the storeNumber which is selected at step 1
            pharmacyList = pharmacyList.filter(pharmacy => pharmacy.StoreNumber !== this.props.selectedStoreNumber);
        }

        if (pharmacyList && pharmacyList.length > 0) {
            if (!isSortedByDistance) { //sort by name and default pharmacy if list is not sorted by distance and value in search is empty.
                pharmacyList = pharmacyList.sort((a, b) => (a.Name > b.Name) ? 1 : -1);
                pharmacyList = pharmacyList.sort(function (a, b) {
                    return b.IsDefault - a.IsDefault;
                });
            }

            pharmacyList = pharmacyList.map((item, index) => {
                return (
                    <div key={index}>
                        <a className="directions-link" onClick={() => this.redirectToMap(item)}>
                            <div className="details-icon-prepend">
                                <div className="icon-col">
                                    <span className="icon-address" />
                                </div>
                                <div className="details-col">
                                    <div>{item.Name} </div>
                                    <div key={item.Address.City}>
                                        <div className="pharmacy-street">{item.Address.StreetAddress}</div>
                                        <div>
                                            {item.Address.City}, {item.Address.State} {item.Address.Zip}
                                            {item.Address.Distance && <span className="miles-away"> - {item.Address.Distance} miles away</span>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                        {item.PhoneNumber &&
                            <a className="phone-link" href={"tel:" + item.PhoneNumber}>
                                <div className="details-icon-prepend">
                                    <div className="icon-col">
                                        <span className="icon-phone" />
                                    </div>
                                    <div className="details-col">
                                        {formatPhoneNumber(item.PhoneNumber)}
                                    </div>
                                </div>
                            </a>
                        }
                        <OperationHours pharmacy={item} />
                        {item.IsDefault &&
                            <div className="your-pharmacy-label">
                                <div className="details-icon-prepend">
                                    <div className="icon-col">
                                        <span className="icon-find-pharmacy" />
                                    </div>
                                    <div className="details-col">Your Pharmacy</div>
                                </div>
                            </div>
                        }
                        <div className="select-pharmacy-btn">
                            {action === 'transfer'
                                ? <button className="btn btn-primary" onClick={() => this.transfer(item, "list")}>Transfer Here</button>
                                : !rxDown && (hasPharmacyLogin || currentPharmacyUser) && !item.IsDefault &&
                                <button className="btn btn-primary" onClick={() => this.showConfirmModal(item)}>Set as My Pharmacy</button>
                            }
                        </div>
                        {pharmacyList[index + 1] ? <div className="hr-divider" /> : null}
                    </div>
                );
            });
        }

        const standalone = !showAsModal && !action;
        let useCurrentLocation = <div className='use-current-loc-dropdown'>Use current location</div>;

        return !rxDown
            ? <div className={`${standalone ? 'container-fluid body-content' : ''} find-pharmacy-container`}>
                <div className="row">
                    <div className={`${standalone ? 'maxWidth-content' : ''} col-12`}>
                        {standalone && !rxDown && (hasPharmacyLogin || (currentPharmacyUser && currentPharmacyUser.pharmacyPatientId))
                            ? <div className="row"><PharmacyHeader /></div>
                            : <h1 className="page-heading">Find a Pharmacy</h1>
                        }
                        {showModal &&
                            <Modal className="verify-modal" isOpen={showModal} centered>
                                <ModalBody>
                                    <div className="row">
                                        <div className="col-12">
                                            <p>Would you like to set this as your default pharmacy?</p>
                                            <div className="row link-container">
                                                <div className="col-6 link-left" onClick={() => this.setDefaultPharmacy()}>YES</div>
                                                <div className="col-6 link-right" onClick={() => this.close(this.state.selectedPharmacy)}>NO</div>
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                        }
                        <div className={"select-pharmacy-results" + (action === 'transfer' ? " transfer-to-pharmacy" : "") + (listView ? " list-view" : " map-view")}>
                            <div className="select-pharmacy__mobile-bar mobile-element">
                                <div className="transfer-to-label">
                                    Transferring To:
                                </div>
                                <div className="list-view-btn" onClick={() => this.setListView(true)}>
                                    <span className="icon-list" /> List View
                                    </div>
                                <div className="map-view-btn" onClick={() => this.setListView(false)}>
                                    <span className="icon-map" /> Map View
                                </div>
                            </div>

                            <div className="select-pharmacy__list">
                                <div className="select-pharmacy-searchbox">
                                    <div className="city-zip-search">
                                        <AutocompleteInput autoFocus value={value} loading={cityZipLoading} noResults={cityZipNoResults}
                                            placeholder="City or Zip" selectOnBlur submitForm={() => this.submitForm(value)}
                                            itemList={cItems} isSearchButton onClickSearch={(val) => this.onSearch(val)}
                                            onChange={(e, val) => this.onCompleteChange(val)}
                                            onSelect={value => this.onCompleteSelect(value)} onClickPreOpen={this.onClickPreOpen}
                                            validTerm="Current Location"
                                            preOpen={isGeoLocation ? useCurrentLocation : null}
                                        />
                                    </div>
                                    {isGeoCurrentLocationDisabled && geoLocationError &&
                                        <div className="geo-location-error-msg">{geoLocationError}</div>}
                                </div>
                                <div className="select-pharmacy-list-content">
                                    {
                                        typeof pharmacyList === 'undefined' || typeof pharmacyListWaiting === 'undefined' || pharmacyListWaiting
                                            ? <SectionLoading />
                                            : !pharmacyServiceError
                                                ? pharmacyList && pharmacyList.length > 0
                                                    ? pharmacyList :
                                                    <SectionLoadingError message="No pharmacy found with your search criteria." sectionErrorClass="no-results-error" />
                                                : <SectionLoadingError message="We’re unable to display the information. Please try again." />
                                    }
                                </div>

                                {selectedPharmacy && showSelectedPharmacy &&
                                    <div className="select-pharmacy-overlay">
                                        <div className="overlay-close-btn">
                                            <a className="icon-close" onClick={() => this.togglePharmacySelection(null)} />
                                        </div>
                                        <a className="directions-link" onClick={() => this.redirectToMap(selectedPharmacy)}>
                                            <div className="details-icon-prepend">
                                                <div className="icon-col">
                                                    <span className="icon-address" />
                                                </div>
                                                <div className="details-col">
                                                    <div>{selectedPharmacy.Name} </div>
                                                    <div key={selectedPharmacy.Address.City}>
                                                        <div className="pharmacy-street">{selectedPharmacy.Address.StreetAddress} </div>
                                                        <div>
                                                            {selectedPharmacy.Address.City}, {selectedPharmacy.Address.State} {selectedPharmacy.Address.Zip}
                                                            {selectedPharmacy.Address.Distance && <span className="miles-away"> - {selectedPharmacy.Address.Distance} miles away</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        {selectedPharmacy.PhoneNumber &&
                                            <a className="phone-link" href={"tel:" + selectedPharmacy.PhoneNumber}>
                                                <div className="details-icon-prepend">
                                                    <div className="icon-col">
                                                        <span className="icon-phone" />
                                                    </div>
                                                    <div className="details-col">
                                                        {formatPhoneNumber(selectedPharmacy.PhoneNumber)}
                                                    </div>
                                                </div>
                                            </a>
                                        }
                                        <OperationHours pharmacy={selectedPharmacy} />
                                        <div className="select-pharmacy-btn">
                                            {action === 'transfer'
                                                ? <button className="btn btn-primary" onClick={() => this.transfer(selectedPharmacy, "map")}>Transfer Here</button>
                                                : !rxDown && hasPharmacyLogin && !selectedPharmacy.IsDefault &&
                                                <button className="btn btn-primary" onClick={() => this.showConfirmModal(selectedPharmacy)}>Set as My Pharmacy</button>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                            {matchingPharmacyList && matchingPharmacyList.length > 0 &&
                                <div className="select-pharmacy__map">
                                    <GoogleMapMain list={matchingPharmacyList} currentLatitude={latitude} currentLongitude={longitude}
                                        zoomOut={!matchingPharmacyList[0].Address.Distance}
                                        getLatitude={item => item.Address.Latitude} getLongitude={item => item.Address.Longitude}
                                        getId={item => item.StoreNumber} getDisplayValue={item => item.Name}
                                        highlightSelectedItem={selectedPharmacy !== null}
                                        onItemSelected={pharmacy => this.togglePharmacySelection(pharmacy)}
                                        onItemDeselected={() => this.togglePharmacySelection(null)}
                                    />
                                    {this.props.closable &&
                                        <div className="close-Map" onClick={() => this.close(null)}>
                                            <span className="icon-close" />
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            : <FeatureDisabled />;
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.sso.isLoggedIn,
        userDetails: state.sso.userDetails,
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        waitingOnGeolocation: state.locations.waitingOnGeolocation,
        latitude: state.locations.latitude,
        longitude: state.locations.longitude,
        geoLocationError: state.locations.geolocationError,
        matchingPharmacyList: state.pharmacy.pharmacyList,
        pharmacyListWaiting: state.pharmacy.isPharmacyListWaiting,
        pharmacyServiceError: state.pharmacy.pharmacyError,
        pharmacyListLoaded: state.pharmacy.pharmacyListLoaded,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        cityAddress: state.locations.city,
        stateAddress: state.locations.state,
        userName: state.domain.un,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getGeoLocation: (useCurrentLocation) => dispatch({ type: types.GEOLOCATION, useCurrentLocation: useCurrentLocation }),
        getPharmacyList: (value, latitude, longitude) => {
            const payload = {};

            if (value === USE_CURRENT_LOCATION) {
                payload.latitude = latitude;
                payload.longitude = longitude;
            }
            else {
                const valueTrimmed = value ? value.split(',')[0].trim() : '';
                if (parseInt(valueTrimmed)) {
                    payload.zip = valueTrimmed;
                }
                else {
                    payload.city = valueTrimmed;
                }
            }
            dispatch({ type: types.PHARMACY_LIST_START, payload: payload });

        },
        getCityZipList: (value) => dispatch({ type: types.CITY_ZIP_LIST, searchModel: { filter: value } }),
        setFavouritePharmacy: (storeNumber, userDetails) =>
            dispatch({ type: types.SET_FAVOURITE_PHARMACY_START, payload: { storeNumber: storeNumber }, userDetails: userDetails })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(FindPharmacy);